import Immutable from 'immutable';

import type { FontAsset } from 'js/src/client';
import { archiveFontWithId, beginLoadingFonts, storeFonts } from 'js/src/data/fonts/fonts-actions';
import { isFontListLoading } from 'js/src/data/fonts/fonts-selectors';
import type { ImmutableMap } from 'js/src/libs/consts';
import FontLoader from 'js/src/libs/font-loader';
import type { AppDispatch } from 'js/src/libs/RootState';
import type { GetRootState } from 'js/src/luminary/luminary-redux-connect-types';

export function loadFonts() {
    return (dispatch: AppDispatch, getState: GetRootState) => {
        if (isFontListLoading(getState())) {
            return;
        }

        dispatch(beginLoadingFonts());
        new FontLoader((fontList) => {
            dispatch(storeFonts({ fontList }));
        });
    };
}

export function archiveFont(fontAsset: ImmutableMap<FontAsset>) {
    return (dispatch: AppDispatch) => {
        FontLoader.deleteFont(fontAsset);
        dispatch(archiveFontWithId({ fontId: fontAsset.get('id') }));
    };
}

export function addFont(fontAsset: ImmutableMap<FontAsset>) {
    return (dispatch: AppDispatch) => {
        FontLoader.addFont(fontAsset);
        dispatch(
            storeFonts({
                fontList: Immutable.List([fontAsset]),
            }),
        );
    };
}
